<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <div class="pa-4">
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" :hide-details="true" />
        </div>

        <div class="mb-4">
          <label class="label-input">Layout</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <label>Background Section</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.styleSection.background"
                    @change="event => (fields.styleSection.background = event.target.value)"
                  />
                  <v-text-field v-model="fields.styleSection.background" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <label>Text Color</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.styleSection.textColor"
                    @change="event => (fields.styleSection.textColor = event.target.value)"
                  />
                  <v-text-field v-model="fields.styleSection.textColor" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  class="mb-0 mt-0"
                  v-model="fields.styleSection.topPadding"
                  label="Top Padding"
                  :hide-details="true"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  class="mb-0 mt-0"
                  v-model="fields.styleSection.bottomPadding"
                  label="Bottom Padding"
                  :hide-details="true"
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-checkbox
                  class="mb-0 mt-0"
                  v-model="fields.containerPage.enableStyle"
                  label="Enable Style Container"
                  :hide-details="true"
                />
                <div v-if="fields.containerPage.enableStyle">
                  <v-row>
                    <v-col cols="12" md="6">
                      <label>Background Color</label>
                      <div class="d-flex align-center gap-3">
                        <input
                          type="color"
                          style="width: 40px; height: 40px; margin-right: 12px"
                          :value="fields.containerPage.background"
                          @change="event => (fields.containerPage.background = event.target.value)"
                        />
                        <v-text-field v-model="fields.containerPage.background" :hide-details="true" class="mt-0" />
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <div class="label-input">Card Title</div>
          <div class="group-item">
            <v-checkbox
              v-model="fields['show-card-title']"
              label="Show card title"
              :hide-details="true"
              class="mb-2 mt-0"
            />
            <ckeditor :editor="editor" v-model="fields['card-title']" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">Review Images</label>
            <v-btn small color="primary" @click="handleAddImage">Add Image</v-btn>
          </div>
          <div class="group-item">
            <v-checkbox
              class="mb-3 mt-0"
              v-model="fields['show-list-image-review']"
              label="Show image list"
              :hide-details="true"
            />
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, index) in fields.images" :key="`review-image-${index}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Image {{ index + 1 }}</span>
                    <v-btn small icon @click.stop="handleRemoveImage(index)">
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <UploadImage
                    @callback="obj => handleUploadImage(obj, index)"
                    :image="{ imageSrc: item }"
                    :height="`220`"
                    :typeUpload="'image'"
                    @callbackDelete="() => handleRemoveUpload(index)"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">Review Text Items</label>
            <v-btn small color="primary" @click="handleAddReview">Add Review</v-btn>
          </div>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="4">
                <v-checkbox
                  class="mb-0 mt-0"
                  v-model="fields['show-list-review-text']"
                  label="Show review list"
                  :hide-details="true"
                />
              </v-col>
              <v-col cols="12" md="4">
                <label>Star Color</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['color-star']"
                    @change="event => (fields['color-star'] = event.target.value)"
                  />
                  <v-text-field v-model="fields['color-star']" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <label>Review Item Background</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['bg-item-review']"
                    @change="event => (fields['bg-item-review'] = event.target.value)"
                  />
                  <v-text-field v-model="fields['bg-item-review']" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
            </v-row>

            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, index) in fields.reviews" :key="`review-item-${index}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Review {{ index + 1 }}</span>
                    <v-btn small icon @click.stop="handleRemoveReview(index)">
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="mb-3">
                    <label>Link</label>
                    <v-text-field v-model="item.link" :hide-details="true" />
                  </div>
                  <div class="mb-3">
                    <v-rating
                      v-model="item.stars"
                      :length="5"
                      size="20"
                      color="primary"
                      background-color="primary"
                      hover
                    />
                  </div>
                  <div class="mb-3">
                    <label>Content</label>
                    <ckeditor :editor="editor" v-model="item.content" :config="editorConfig" />
                  </div>
                  <v-checkbox
                    class="mb-2 mt-0"
                    v-model="item['show-button']"
                    label="Show button"
                    :hide-details="true"
                  />
                  <div class="mb-3">
                    <label>Button Text</label>
                    <v-text-field v-model="item['button-text']" :hide-details="true" />
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </div>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '../common/form/upload-file/upload-image.vue';
import { updateHtmlFromData } from '../common/html/update';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';

const defaultReviewItem = () => ({
  link: '#',
  stars: 5,
  content:
    "<h3>Perfect Fit</h3><p>This is honestly the best bra I've ever worn. l can't even feel that I'm wearing it.It definitely minimizes-I did the jump and shake test, and the girls fully stayed inplace.</p>",
  'show-button': true,
  'button-text': 'SHOP THIS ITEM',
});

const defaultFields = {
  title: 'Card Review Hsia Grid Section',
  'card-title':
    '<h2>Over 200K+ Happy Customers</h2><p>Best-of-the-best minimizer bra wardrobe staples, A perfect blend of comfort, support, and a flattering sihouette.</p>',
  'show-card-title': true,
  styleSection: {
    topPadding: true,
    bottomPadding: true,
    background: '#FFFFFF',
    textColor: '#000000',
  },
  containerPage: {
    enableStyle: false,
    background: '#FFFFFF',
  },
  'show-list-image-review': true,
  images: [],
  'show-list-review-text': true,
  'color-star': '#b75d3e',
  'bg-item-review': '#f7f7f7',
  reviews: [defaultReviewItem(), defaultReviewItem()],
};

export default {
  name: 'CardReviewHsiaGrid',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: { ...defaultFields },
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
    };
  },
  mounted() {
    const extracted = this.sectionEditor.sectionExtract || {};
    this.fields = {
      ...this.fields,
      ...extracted,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const payload = {
        ...this.fields,
        images: (this.fields.images || []).filter(Boolean),
        reviews: (this.fields.reviews || []).filter(Boolean).map(item => ({
          link: item.link || '#',
          stars: Number.isFinite(Number(item.stars)) ? Math.max(0, Math.min(5, Number(item.stars))) : 5,
          content: item.content || '',
          'show-button': item['show-button'] !== false,
          'button-text': item['button-text'] || 'SHOP THIS ITEM',
        })),
      };

      if (!payload.reviews.length) {
        payload.reviews = [defaultReviewItem()];
      }

      const updateHtml = updateHtmlFromData.sectionCardReviewHsiaGrid(this.sectionEditor.section.html, payload);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: payload.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddImage() {
      this.fields.images.push('');
    },
    handleRemoveImage(index) {
      if (this.fields.images.length <= 1) return;
      this.fields.images.splice(index, 1);
    },
    handleUploadImage(obj, index) {
      this.$set(this.fields.images, index, obj.imageSrc || '');
    },
    handleRemoveUpload(index) {
      this.$set(this.fields.images, index, '');
    },
    handleAddReview() {
      this.fields.reviews.push(defaultReviewItem());
    },
    handleRemoveReview(index) {
      if (this.fields.reviews.length <= 1) return;
      this.fields.reviews.splice(index, 1);
    },
    handleUpdateStars(value, index) {
      const parsed = Number(value);
      this.fields.reviews[index].stars = Number.isFinite(parsed) ? Math.max(0, Math.min(5, parsed)) : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 5px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.group-item {
  border: 1px solid #0000000f;
  border-radius: 8px;
  padding: 16px 12px;
  margin-bottom: 10px;
}
</style>
